import React from 'react';
import {Container, Header} from '@amzn/awsui-components-react';
import ReactEcharts from 'echarts-for-react';
import {SeriesOption} from 'echarts/types/dist/shared';
import {chartColorsLight} from '../../common/colors';

const COMPONENT_TEXTS = {
    chart_description: 'Each metric shows the contribution to the final forecast.',
} as const;

export default function BoscoExplainerLineChart({data, forecastColumns, contributionColumns, friendlyNameMapping}) {
    const series: SeriesOption[] = forecastColumns.map((col) => ({
        name: friendlyNameMapping[col],
        type: 'line',
        encode: {
            x: 'balanceDate',
            y: col,
        },
        symbol: 'none',
        lineStyle: {
            width: 2,
        },
        xAxisIndex: 0,
        yAxisIndex: 0,
        emphasis: {
            disabled: true,
        },
    }));

    const series2: SeriesOption[] = contributionColumns.map((col) => ({
        name: friendlyNameMapping[col],
        type: 'line',
        encode: {
            x: 'balanceDate',
            y: col,
        },
        symbol: 'none',
        lineStyle: {
            width: 2,
        },
        xAxisIndex: 1,
        yAxisIndex: 1,
        emphasis: {
            disabled: true,
        },
    }));

    const option = {
        dataset: {
            dimensions: ['balanceDate', ...contributionColumns, ...forecastColumns],
            source: data,
        },
        tooltip: {
            trigger: 'axis',
            valueFormatter: (value: number) => value?.toFixed(2),
        },
        axisPointer: {
            type: 'cross',
            link: [
                {
                    xAxisIndex: 'all',
                },
            ],
        },
        color: chartColorsLight,
        legend: [
            {
                data: forecastColumns.map((col) => friendlyNameMapping[col]),
                top: '0%',
                left: 'center',
                type: 'scroll',
            },
            {
                data: contributionColumns.map((col) => friendlyNameMapping[col]),
                top: '53%',
                left: 'center',
                type: 'scroll',
            },
        ],
        grid: [
            {
                top: '7%',
                height: '35%',
            },
            {
                top: '60%',
                height: '35%',
            },
        ],
        xAxis: [
            {
                gridIndex: 0,
                type: 'category',
                name: 'Date',
                nameLocation: 'middle',
                nameGap: 30,
                boundaryGap: false,
            },
            {
                gridIndex: 1,
                type: 'category',
                name: 'Date',
                nameLocation: 'middle',
                nameGap: 30,
                boundaryGap: false,
            },
        ],
        yAxis: [
            {
                gridIndex: 0,
                type: 'value',
                name: 'Value',
                nameLocation: 'middle',
                nameGap: 50,
            },
            {
                gridIndex: 1,
                type: 'value',
                name: 'Value',
                nameLocation: 'middle',
                nameGap: 50,
            },
        ],
        series: [...series, ...series2] as SeriesOption[],
    };

    return (
        <Container
            header={
                <Header variant="h2" description={COMPONENT_TEXTS.chart_description}>
                    Forward Looking Explainability
                </Header>
            }
        >
            <ReactEcharts option={option} style={{height: '50vh'}} opts={{renderer: 'svg'}} data-testid="page-line-chart" />
        </Container>
    );
}
